module.exports = __webpack_public_path__ + "static/img/logo_blue.9d4ecf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_blue.png
// module id = Aa1Y
// module chunks = 49